import React from 'react';
import './FooterNav.scss';
import brandImg from '../../../../assets/image/sudexlogo.png';
import {Link} from 'react-router-dom'
const FooterNav = () => {
    return (
        <div className="footernav">
            <div className="container footernav-content">
                <a href="/" className="footer-logo">
                    <img src={brandImg} /><span className="brand-name">Sudex</span>
                </a>
                <div className="footer-links">
                    <Link to="/" href="#">
                        Bosh Sahifa
                    </Link>
                    <Link to="/categories" href="#">
                        Kategoriyalar
                    </Link>
                    <Link to="/history" href="#">
                        Arxiv
                    </Link>
                </div>
                <div className="social-media">
                    <a href="#"><i className="fab fa-telegram"></i></a>
                    <a href="#"><i className="fab fa-facebook"></i></a>
                    <a href="#"><i className="fab fa-instagram"></i></a>
                </div>
            </div>
        </div>
    );
}

export default FooterNav;
